import React from 'react';
import { connect } from "react-redux";
import {Grid} from "semantic-ui-react";
import VeritasHeader from "../../shared/VeritasHeader";
import Breadcrumb from '../../../common/partials/Breadcrumb';
import { setBreadCrumb } from '../../breadcrumb/BreadcrumbActions';
import {fetchAllCountries} from "../actions/CountriesActions";
import CountriesTable from "./CountriesTable";
import {InlineLoading} from "../../../common/partials/Loading";
import Sidebar from "../../../common/components/Sidebar";
import VeritasSidebarButtons from "../../shared/VeritasSidebarButtons";

export class CountryCoverageListPage extends React.Component {

    componentDidMount() {
        document.title = `Veritas - Country Coverage`;
        this.props.setBreadCrumb({
            parent: { url: '/veritas', text: 'Veritas' },
            list: { url: '/veritas/country-coverage', text: 'Country Coverage' },
            service: { url: '', text: '' },
            source: { url: '', text: '' }
        })

        if (this.props.all_countries.length === 0) {
            this.props.getAllCountries();
        }
    }

    render() {
        return (
            <div className="veritas">
                <VeritasHeader />
                <Grid relaxed={true}>
                    <Grid.Column width={3}>
                        {/*In next iteration, break this into its own sidebar, */}
                        {/*with countries specific filters*/}
                        <Sidebar>
                            <VeritasSidebarButtons />
                        </Sidebar>
                    </Grid.Column>
                    <Grid.Column width={13}>
                        <Breadcrumb />
                        {this.props.filtered_all_countries
                            ? (<CountriesTable Countries={this.props.filtered_all_countries} />)
                            : (<InlineLoading />)
                        }
                    </Grid.Column>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    all_countries: state.veritas.countries.all_countries,
    filtered_all_countries: state.veritas.countries.filtered_all_countries,
    all_organizations: state.veritas.providers.all_organizations
});

const mapDispatchToProps = dispatch => ({
    getAllCountries: () => {dispatch(fetchAllCountries())},
    setBreadCrumb: (crumb) => { dispatch(setBreadCrumb(crumb)) },
});


export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(CountryCoverageListPage)
